import type { AppContext } from './appContext';
import { saveFile } from './fileLifecycle';
import { CHESS_JOURNAL_PATH, CHESS_JOURNAL_SECTION } from './constants';
import type { DatabaseFile, Section } from '../types';
import { buildChessGameJournalItem } from '../utils/chessGameJournalItem';
import { insertItemIntoSection } from '../utils/itemMove';
import type { ChessPlayerColor } from '../utils/chessPgnMeta';

function findGamesSection(file: DatabaseFile): Section {
  let section = file.sections.find(
    s => s.title.trim().toLowerCase() === CHESS_JOURNAL_SECTION.toLowerCase()
  );
  if (!section) {
    section = { title: CHESS_JOURNAL_SECTION, level: 2, items: [], prose: [] };
    file.sections.push(section);
  }
  return section;
}

async function loadChessJournalFile(ctx: AppContext): Promise<DatabaseFile> {
  if (!ctx.allPaths.includes(CHESS_JOURNAL_PATH)) {
    throw new Error(
      `Missing ${CHESS_JOURNAL_PATH} in your repo. Add that page with a ## ${CHESS_JOURNAL_SECTION} section.`
    );
  }
  return ctx.fileRegistry.ensureLoaded(CHESS_JOURNAL_PATH);
}

/** Append coach analysis + PGN as a new item in database/chess.md → Games. */
export async function appendChessGameAnalysisToJournal(
  ctx: AppContext,
  opts: {
    pgn: string;
    analysis: string;
    playerColor: ChessPlayerColor | null;
    headline?: string;
  }
): Promise<void> {
  const file = await loadChessJournalFile(ctx);
  const section = findGamesSection(file);
  const item = buildChessGameJournalItem({
    pgn: opts.pgn,
    analysis: opts.analysis,
    playerColor: opts.playerColor,
    ...(opts.headline ? { headline: opts.headline } : {}),
  });
  insertItemIntoSection(section, item);
  await saveFile(ctx, file);
}
